// extracted by mini-css-extract-plugin
export default {"center":"Events_center__5cy0g","background":"Events_background__mpEPO","grid":"Events_grid__n+nnZ"};